import { render, staticRenderFns } from "./Somos1Report.vue?vue&type=template&id=132c6dd0&scoped=true"
import script from "./Somos1Report.vue?vue&type=script&lang=js"
export * from "./Somos1Report.vue?vue&type=script&lang=js"
import style0 from "./Somos1Report.vue?vue&type=style&index=0&id=132c6dd0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c6dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132c6dd0')) {
      api.createRecord('132c6dd0', component.options)
    } else {
      api.reload('132c6dd0', component.options)
    }
    module.hot.accept("./Somos1Report.vue?vue&type=template&id=132c6dd0&scoped=true", function () {
      api.rerender('132c6dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/Somos1Report.vue"
export default component.exports